/**
 * isReactComponent
 *
 * Created by Samuel on 2022/8/15
 */
import { createElement, isValidElement } from 'react';

export function isReactComponent(component) {
	if (component == null || component === '') {
		return false;
	}
	if (isClassComponent(component)) {
		return true;
	}
	if (isExoticComponent(component)) {
		return true;
	}
	if (typeof component === 'function') {
		try {
			return isValidElement(createElement(component));
		} catch (e) {
			return false;
		}
	}
	return false;
}
function isClassComponent(component) {
	return (
		typeof component === 'function' &&
		(() => {
			const proto = Object.getPrototypeOf(component);
			return proto.prototype && proto.prototype.isReactComponent;
		})()
	);
}

function isExoticComponent(component) {
	return (
		typeof component === 'object' &&
		typeof component.$$typeof === 'symbol' &&
		['react.memo', 'react.forward_ref'].includes(component.$$typeof.description)
	);
}
